import { useState } from "react";
import { INavbarItem } from "../../../Interfaces/NavbarInterfaces";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import NavbarItem from "./NavbarItem";
import { toast } from "react-toastify";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../Requests/authRequests";
import { clearAuthStorage } from "../../../helper";

interface IProps {
  navbarItems: Array<INavbarItem> | null;
}

const Navbar = ({ navbarItems }: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [openNavbarId, setOpenNavbarId] = useState(-1);

  const logoutHandler = () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (!token) return;
    logout(token)
      .then(() => {
        clearAuthStorage();
        navigate("/");
      })
      .catch(() => toast.error("عدم ارتباط با سرور"))
      .finally(() => setLoading(false));
  };

  if (loading) return <FullScreenLoading />;
  if (navbarItems && navbarItems.length)
    return (
      <div className="bg-sky-600 w-full flex flex-row justify-start align-center gap-5 p-2 z-[101]">
        {navbarItems.map((navbarItem) => {
          return (
            <NavbarItem
              title={navbarItem.title}
              address={navbarItem.address}
              key={navbarItem.address}
              openItemId={openNavbarId}
              setOpenItemId={setOpenNavbarId}
              id={navbarItem.id}
              children={navbarItem.children}
            />
          );
        })}
        <LogoutRoundedIcon
          className="text-white mr-auto cursor-pointer hover:text-blue-200"
          onClick={logoutHandler}
        />
      </div>
    );
  return <></>;
};

export default Navbar;
